module.exports = __webpack_public_path__ + "img/logo.4f7c76e1.png";